// extracted by mini-css-extract-plugin
export default {"airplaneSizingContainer":"vba-z","narrowOptionButtons":"wba-z","noOptions":"xba-z"};